import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/wage-info.module.scss';
import InfoItem from 'src/components/InfoItem';
import { IWage } from 'src/types/wage';
import RoleLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';

export interface StateProps {
    wage: Partial<IWage> | null;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const WageInfo: React.FunctionComponent<Props> = ({
    wage,
    getData,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData]);

    if (!wage) {
        return null;
    }
    //const { id } = wage;
    return (
        <RoleLayout>
            <div>
                <h2>
                    WAGES {`>`} {id}
                </h2>
            </div>

            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}>
                    <InfoItem title={'Full Name:'} value={id} />
                </div>

                <div>
                    <Link
                        className={classNames('btn', 'btn-outline-secondary')}
                        to={Router.generate(routes.WAGE_EDIT, { id })}
                    >
                        EDIT
                    </Link>
                </div>
            </div>
        </RoleLayout>
    );
};

export default WageInfo;
